// ----------------------------------------------------------------------

function path(root, sublink) {
    return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = '/dashboard';
const ROOTS_MAIN = '/main';
const ROOTS_USER = '/user';
const ROOTS_REPORT = '/report';
// ----------------------------------------------------------------------

export const PATH_AUTH = {
    login: '/login',
};
export const PATH_LOGINSELECTIONAUTH = {
    loginselection: '/loginselection',
};
export const PATH_DEALERAUTH = {
    dealerauthlogin: '/dealerlogin/oauth2_callback',
};
export const PATH_DEALER = {
    dealerlogin: '/dealerlogin',
};

export const PATH_LOGOUT = {
    logout: '/',
};

export const PATH_ALLPROJECT = {
    allprojectsaccess: '/allprojectsaccess',
};

export const PATH_MAIN = {
    root: ROOTS_MAIN,
    // one: path(ROOTS_MAIN, '/one'),
    master: {
        root: path(ROOTS_MAIN, '/master'),
        one: path(ROOTS_MAIN, '/master/one'),
        two: path(ROOTS_MAIN, '/master/two'),
        three: path(ROOTS_MAIN, '/master/three'),
        four: path(ROOTS_MAIN, '/master/four'),
        five: path(ROOTS_MAIN, '/master/five'),
        six: path(ROOTS_MAIN, '/master/six'),
    },
};

export const PATH_DASHBOARD = {
    root: ROOTS_DASHBOARD,
    one: path(ROOTS_DASHBOARD, '/one'),
    two: path(ROOTS_DASHBOARD, '/two'),
    three: path(ROOTS_DASHBOARD, '/three'),
    user: {
        root: path(ROOTS_DASHBOARD, '/user'),
        four: path(ROOTS_DASHBOARD, '/user/four'),
        five: path(ROOTS_DASHBOARD, '/user/five'),
        six: path(ROOTS_DASHBOARD, '/user/six'),
    },
};

export const PATH_USER = {
    root: ROOTS_USER,
    login: path(ROOTS_USER, '/login'),
    user: path(ROOTS_USER, '/user'),
    // allprojectsaccess: path(PATH_AUTH, '/allprojectsaccess'),
    moduleroleaccesslistpage: path(ROOTS_USER, '/moduleroleaccesslistpage'),
};

export const PATH_REPORT = {
    root: ROOTS_REPORT,
    moduleroleaccesslistreport: path(ROOTS_REPORT, '/moduleroleaccesslistreport'),
};